import api from './api';
import Storage from '@/utils/storage';
import { COMMITTEE_KEYS } from '@/utils/constant';
import { serialize } from '@/utils';

const tokenKey = COMMITTEE_KEYS.vtoken;
const utilityName = 'utility';

const assetsUrl = (relativePath) => {
	return `${import.meta.env.VITE_BASE_URL}/${relativePath}`;
};

export default {
	getConstants () {
		const token = Storage.get(tokenKey);

		return api.get(`${utilityName}/get-constants`, { token });
	},
	getCountries (params = null) {
		const token = Storage.get(tokenKey);

		params = {
			...params,
			status: 1
		}
		let uri = `countries`;
		const str = serialize(params);
		if (str) uri += `?${str}`;

		return api.get(uri, { token });
	},
	async getCountryCodes () {
		const response = await fetch(assetsUrl('media/country-flags.json'));
		return { data: (await response.json()) || [], status: 200 };
	},
	getCountryCurrent () {
		return api.get(`${utilityName}/get-country-code`);
	},
	getSchools (params = null) {
		const token = Storage.get(tokenKey);

		params = {
			...params,
			active_for_ranking: 1,
			system_type: 'main_school',
		}
		let uri = `schools`;
		const str = serialize(params);
		if (str) uri += `?${str}`;

		return api.get(uri, { token });
	},
	getPalmList (params = null) {
		const token = Storage.get(tokenKey);

		let uri = `palms`;
		const str = serialize(params);
		if (str) uri += `?${str}`;

		return api.get(uri, { token });
	},
};
